import { render } from "./FollowedTagCard.vue?vue&type=template&id=349099ce&scoped=true"
import script from "./FollowedTagCard.vue?vue&type=script&lang=js"
export * from "./FollowedTagCard.vue?vue&type=script&lang=js"

import "./FollowedTagCard.vue?vue&type=style&index=0&id=349099ce&scoped=true&lang=css"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349099ce"]])

export default __exports__